import script from "./MyInscriptions.vue?vue&type=script&setup=true&lang=js"
export * from "./MyInscriptions.vue?vue&type=script&setup=true&lang=js"

import "./MyInscriptions.vue?vue&type=style&index=0&id=02dbfb4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02dbfb4e"]])

export default __exports__